import type { SiteConfig } from '@/types'

/**
 * The published address. Used for absolute links in share tags (og:url, og:image), so it must be a
 * fixed value rather than the browser's origin, which does not exist while a page is rendered.
 */
export const SITE_URL = 'https://norrvik.modulify.website'

export const siteConfig: SiteConfig = {
    name: 'Norrvik',
    description: 'Norrvik is an architecture and building-intelligence studio in Stockholm and Lisbon. We survey, design and monitor buildings, and keep the model alive after handover.',
    url: SITE_URL
}
